module.exports = __webpack_public_path__ + "img/icon-calendar.bf71e16d.svg";